<div class="popup marginBottomStyle" style="position: relative; height: 100%;">

  <!-- OPTIONAL: Import SQL panel -->
  <!-- <div style="margin-bottom: 10px; padding: 10px; border: 1px solid #ddd; background: #fafafa;">
    <label style="font-weight: 600;">Import SQL (bind back to builder)</label>
    <textarea rows="3" style="width: 100%;" [(ngModel)]="importSqlText" placeholder="Paste SQL here"></textarea>
    <button mat-raised-button (click)="importSqlToBuilder(importSqlText)">Import</button>

    <div *ngIf="importErrors?.length" style="margin-top: 6px;">
      <div *ngFor="let e of importErrors" style="color: #d32f2f;">{{ e }}</div>
    </div>
  </div> -->

  <button *ngIf="queryType == 'unionQuery'"
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor"
          title="Remove"
          id="114"
          style="width: 25px;background-color: rgb(253, 152, 13);position: absolute;height: 25px;top: -30px;right: -30px;box-shadow: none !important;"
          (click)="removeUnion(unionIndex)">✖</button>

  <div class="container" style="margin: 0;padding: 0;">
    <div class="row">
      <div class="col-lg-3" *ngIf="queryType=='unionQuery'">
        <mat-form-field class="filter" appearance="outline">
          <mat-label>Select UNION Operator</mat-label>
          <mat-select [(ngModel)]="selectUnionType" (selectionChange)="generateQuery()">
            <mat-option value="UNION">UNION</mat-option>
            <mat-option value="UNION ALL">UNION ALL</mat-option>
            <mat-option value="INTERSECT">INTERSECT</mat-option>
            <mat-option value="MINUS">MINUS</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-3" *ngIf="queryType != 'unionQuery'">
        <mat-form-field class="filter" appearance="outline">
          <mat-label>Select Command</mat-label>
          <mat-select [(ngModel)]="selectedCommand" (selectionChange)="generateQuery()">
            <mat-option value="">None</mat-option>
            <mat-option value="SELECT">SELECT</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-3" style="display:flex;">
        <mat-form-field appearance="outline">
          <mat-label>Alias</mat-label>
          <input matInput type="text" placeholder="Alias" [(ngModel)]="objectAlias" (input)="generateQuery()">
        </mat-form-field>
      </div>

      <div class="col-lg-3">
        <mat-form-field class="filter" appearance="outline">
          <mat-label>Select Object</mat-label>
          <mat-select [(ngModel)]="selectedObject" (selectionChange)="onObjectSelectionChange($event)">
            <mat-option value="">None</mat-option>
            <mat-option value="addFromQuery">Add From Query</mat-option>
            <mat-option *ngFor="let table of tables" [value]="table.objectId">
              {{ table.objectName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
  <div class="col-lg-12">
    <div class="row topRowMargins" style="margin:auto;margin-bottom:2%;">
      <div style="width:15%;">
        <label style="font-weight:500;font-size:medium;color:black;">SELECT Columns</label>
      </div>
      <div>
        <label (click)="addSelectItem()" style="margin:auto;background:green;padding:0px 5px;border-radius:15px;">
          <em class="fas fa-plus" style="color:antiquewhite;font-size:medium;" title="Add"></em>
        </label>
      </div>
    </div>

    <div *ngFor="let item of selectedColumns; let i = index" 
         style="display: flex; gap: 10px; margin-bottom: 15px; align-items: flex-start; flex-wrap: wrap; border-bottom: 1px solid #eee; padding-bottom: 10px;">
      
          <mat-form-field appearance="outline" style="min-width: 200px; flex: 2;">
            <mat-label>Column</mat-label>
            <mat-select [(ngModel)]="item.column" (selectionChange)="generateQuery()">
              <mat-option *ngFor="let col of columns" [value]="col.name">
                {{ col.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="min-width: 120px; flex: 1;">
            <mat-label>Aggregate</mat-label>
            <mat-select [(ngModel)]="item.aggregate" (selectionChange)="generateQuery()">
              <mat-option value="">None</mat-option>
              <mat-option value="COUNT">COUNT</mat-option>
              <mat-option value="SUM">SUM</mat-option>
              <mat-option value="AVG">AVG</mat-option>
              <mat-option value="MIN">MIN</mat-option>
              <mat-option value="MAX">MAX</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox [(ngModel)]="item.distinct" 
                        (change)="generateQuery()"
                        [disabled]="!item.aggregate"
                        >
            DISTINCT
          </mat-checkbox>
       

        <!-- Expression Mode -->
        <!-- <ng-container *ngSwitchCase="'expression'">
          <mat-form-field appearance="outline" style="min-width: 400px; flex: 3;">
            <mat-label>SQL Expression</mat-label>
            <input matInput [(ngModel)]="item.expression" (input)="generateQuery()"
                   placeholder="e.g., drug_name || '||' || event_type">
          </mat-form-field>
        </ng-container>
      </ng-container> -->

      <!-- Alias (common) -->
      <mat-form-field appearance="outline" style="min-width: 150px; flex: 1;">
        <mat-label>Alias (optional)</mat-label>
        <input matInput [(ngModel)]="item.alias" (input)="generateQuery()">
      </mat-form-field>

      <!-- Remove button -->
      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="buttonColor"
              title="Remove"
              (click)="removeSelectItem(i)"
              style="width:40px; height:40px; box-shadow:none!important; background-color:rgb(253,152,13);">
        ✖
      </button>
    </div>

    <!-- No items placeholder -->
    <div *ngIf="!selectedColumns.length" style="margin-bottom:10px; color:#666;">
      <em>No columns selected. Click + to add.</em>
    </div>
  </div>
</div>

    <!-- Subquery FROM -->
    <div class="row" *ngIf="selectedTables[0] == 'addFromQuery'"
         style="margin: 1% 3%; background: #f3f3f3; border: 1px solid black; padding: 1%;">
      <div class="col-lg">
          <app-sql-query-builder
            [objectList]="objectList"
            [queryType]="'subQuery'"
            [showUnions]="false"
            [fromJSIPFormulaBuilder]="fromJSIPFormulaBuilder"
            [importedSql]="subSqlQuery"
            (valueChange)="handleChildValue($event)">
          </app-sql-query-builder>
      </div>
    </div>

    <!-- JOIN -->
    <div>
      <div class="row">
        <div class="col-lg">
          <div class="row topRowMargins" style="margin:auto;margin-bottom:2%;">
            <div style="width:15%;">
              <label style="font-weight:500;font-size:medium;color:black;">JOIN Conditions</label>
            </div>
            <div>
              <label (click)="addJoin()" style="margin:auto;background:green;padding:0px 5px;border-radius:15px;">
                <em class="fas fa-plus" style="color:antiquewhite;font-size:medium;" title="Add"></em>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngFor="let join of selectedJoins; let i=index">
        <div class="col-lg-3">
          <mat-form-field class="filter" appearance="outline">
            <mat-label>Select JOIN</mat-label>
            <mat-select [(ngModel)]="join.type" (selectionChange)="generateQuery()">
              <mat-option *ngFor="let type of joinTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3" style="display:flex;">
          <mat-form-field appearance="outline">
            <mat-label>Alias</mat-label>
            <input matInput type="text" placeholder="Alias" [(ngModel)]="join.alias" (input)="generateQuery()">
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field class="filter" appearance="outline">
            <mat-label>Select Object</mat-label>
            <mat-select [(ngModel)]="join.objectId" (selectionChange)="onJoinObjectSelectionChange($event,i)">
              <mat-option *ngFor="let table of tables" [value]="table.objectId">
                {{ table.objectName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field class="filter" appearance="outline">
            <mat-label>Select Attributes</mat-label>
            <mat-select [(ngModel)]="join.selectedColumns" multiple (selectionChange)="generateQuery()">
              <mat-option *ngFor="let col of join.attributesList" [value]="col.name">
                {{ col.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3" style="display:flex;">
          <mat-form-field appearance="outline" style="width:80%;">
            <mat-label>Condition</mat-label>
            <input matInput type="text" placeholder="Value" [(ngModel)]="join.onCondition" (input)="generateQuery()">
          </mat-form-field>

          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="buttonColor"
                  title="Remove"
                  (click)="removeJoin(i)"
                  id="114"
                  style="width:10%;box-shadow:none!important;background-color:rgb(253,152,13);height:25px;font-size:medium;">✖</button>
        </div>
      </div>
    </div>

    <!-- WHERE -->
    <div>
      <div class="row">
        <div class="col-lg">
          <div class="row topRowMargins" style="margin:auto;margin-bottom:1%;">
            <div style="width:15%;">
              <label style="font-weight:500;font-size:medium;color:black;">WHERE Conditions</label>
            </div>
            <div>
              <label (click)="addNonGroupCondition()" style="margin:auto;background:green;padding:0px 5px;border-radius:15px;">
                <em class="fas fa-plus" style="color:antiquewhite;font-size:medium;" title="Add"></em>
              </label>
            </div>
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    [style.background-color]="buttonColor"
                    (click)="addGroup()"
                    id="114"
                    style="margin-left:1%;margin-top:0;height:25px;box-shadow:none!important;">Add Group</button>
          </div>
        </div>
      </div>

      <div style="max-height:300px; overflow-y:auto; overflow-x:hidden; width:100%; padding:2%; padding-left:0; padding-bottom:0;">

        <!-- Non-grouped -->
        <div class="row" *ngFor="let cond of nonGroupedConditions; let i = index">
          <div class="col-lg-3">
            <mat-form-field class="filter" appearance="outline">
              <mat-label>Select Attribute</mat-label>
              <mat-select [(ngModel)]="cond.column" (selectionChange)="generateQuery()">
                <mat-option *ngFor="let col of columns" [value]="col.name">{{ col.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-3">
            <mat-form-field appearance="outline">
              <mat-label>Select Condition</mat-label>
              <mat-select [(ngModel)]="cond.conditionalOperator" (selectionChange)="generateQuery()">
                <mat-option value="=">=</mat-option>
                <mat-option value="!=">!=</mat-option>
                <mat-option value=">">></mat-option>
                <mat-option value="<"><</mat-option>
                <mat-option value="IN">IN</mat-option>
                <mat-option value="LIKE">LIKE</mat-option>
                <mat-option value="IS NULL">IS NULL</mat-option>
                <mat-option value="IS NOT NULL">IS NOT NULL</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-3" style="display:flex;">
            <mat-form-field appearance="outline" [ngStyle]="{'width': i == 0 ? '80%' : '100%'}">
              <mat-label>Value</mat-label>
              <input matInput type="text" placeholder="Value" [(ngModel)]="cond.value" (input)="generateQuery()">
            </mat-form-field>

            <!-- ✅ FIX: always allow remove -->
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    [style.background-color]="buttonColor"
                    title="Remove"
                    (click)="removeNonGroupCondition(i)"
                    id="114"
                    style="width:10%;box-shadow:none!important;background-color:rgb(253,152,13);height:25px;font-size:medium;">✖</button>
          </div>

          <div class="col-lg-3" *ngIf="i > 0" style="display:flex;">
            <mat-form-field class="filter" appearance="outline" style="width:80%;">
              <mat-label>Select Operators</mat-label>
              <mat-select [(ngModel)]="cond.operator" (selectionChange)="generateQuery()">
                <mat-option value="AND">AND</mat-option>
                <mat-option value="OR">OR</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Groups -->
        <div *ngFor="let group of groups; let gIdx = index"
             style="border: 1px solid #ccc; padding: 10px; margin-bottom: 15px; position: relative;">

          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="buttonColor"
                  title="Remove Group"
                  (click)="removeGroup(gIdx)"
                  id="114"
                  style="width:25px;box-shadow:none!important;background-color:rgb(253,152,13);height:25px;font-size:medium;top:-20px;position:absolute;right:-15px;">✖</button>

          <div class="row" *ngIf="nonGroupedConditions.length > 0 || gIdx > 0">
            <div class="col-lg-3" style="display:flex;">
              <mat-form-field class="filter" appearance="outline" style="width:80%;">
                <mat-label>Group Operator</mat-label>
                <mat-select [(ngModel)]="group.groupOperator" (selectionChange)="generateQuery()">
                  <mat-option value="AND">AND</mat-option>
                  <mat-option value="OR">OR</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row" *ngFor="let cond of group.conditions; let cIdx = index">
            <div class="col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Select Attribute</mat-label>
                <mat-select [(ngModel)]="cond.column" (selectionChange)="generateQuery()">
                  <mat-option *ngFor="let col of columns" [value]="col.name">{{ col.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Select Condition</mat-label>
                <mat-select [(ngModel)]="cond.conditionalOperator" (selectionChange)="generateQuery()">
                  <mat-option value="=">=</mat-option>
                  <mat-option value="!=">!=</mat-option>
                  <mat-option value=">">></mat-option>
                  <mat-option value="<"><</mat-option>
                  <mat-option value="IN">IN</mat-option>
                  <mat-option value="LIKE">LIKE</mat-option>
                  <mat-option value="IS NULL">IS NULL</mat-option>
                  <mat-option value="IS NOT NULL">IS NOT NULL</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-3" style="display:flex;">
              <mat-form-field appearance="outline" [ngStyle]="{'width': cIdx == 0 ? '80%' : '100%'}">
                <mat-label>Value</mat-label>
                <input matInput [(ngModel)]="cond.value" (input)="generateQuery()" />
              </mat-form-field>

              <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                      [style.background-color]="buttonColor"
                      title="Remove"
                      (click)="removeCondition(gIdx, cIdx)"
                      id="114"
                      style="width:10%;box-shadow:none!important;background-color:rgb(253,152,13);height:25px;font-size:medium;">✖</button>
            </div>

            <div class="col-lg-3" *ngIf="cIdx > 0" style="display:flex;">
              <mat-form-field appearance="outline" style="width:80%;">
                <mat-label>Select Operators</mat-label>
                <mat-select [(ngModel)]="cond.operator" (selectionChange)="generateQuery()">
                  <mat-option value="AND">AND</mat-option>
                  <mat-option value="OR">OR</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div style="margin-top: 5px;">
            <label (click)="addCondition(gIdx)" style="margin:auto;background:green;padding:0px 5px;border-radius:15px;">
              <em class="fas fa-plus" style="color:antiquewhite;font-size:medium;" title="Add"></em>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- GROUP BY -->
<div class="row">
  <div class="col-lg-3">
    <div class="row topRowMargins" style="margin:auto;margin-bottom:1%;">
      <div style="width:15%;">
        <label style="font-weight:500;font-size:medium;color:black;">GROUP BY</label>
      </div>
    </div>
    <mat-form-field appearance="outline" style="width:100%;">
      <mat-label>Select columns to group by</mat-label>
      <mat-select [(ngModel)]="groupByColumns" multiple (selectionChange)="generateQuery()">
        <mat-option *ngFor="let col of columns" [value]="col.name">
          {{ col.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

    <!-- SET Operators (Union children) -->
    <div *ngIf="showUnions">
      <div class="row">
        <div class="col-lg">
          <div class="row topRowMargins" style="margin:auto;margin-bottom:2%;">
            <div style="width:15%;">
              <label style="font-weight:500;font-size:medium;color:black;">SET Operators</label>
            </div>
            <div>
              <label (click)="addUnion()" style="margin:auto;background:green;padding:0px 5px;border-radius:15px;">
                <em class="fas fa-plus" style="color:antiquewhite;font-size:medium;" title="Add"></em>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngFor="let union of selectedUnions; let i=index">
        <div class="col-lg" style="margin:1% 3%; background:#f3f3f3; border:1px solid black; padding:1%;">
         <app-sql-query-builder
  [objectList]="objectList"
  [queryType]="'unionQuery'"
  [showUnions]="false"
  [fromJSIPFormulaBuilder]="fromJSIPFormulaBuilder"
  [unionIndex]="i"
  [importedSql]="selectedUnionQueries[i]"     
  (unionQueryChange)="handleUnionQueries($event)">
</app-sql-query-builder>

        </div>
      </div>
    </div>

  </div>
</div>
